import { getQueryParams } from 'constants/helper';

export const getDetailsFromCompetencySidePanelRoute = ({ queryString }) => {
  const {
    empId,
    competencyId,
    levelUpCompetencyId,
    levelUpId,
    scrollToId,
    checkInInstanceId,
    checkInParentId,
    isOneOnOne,
  } = getQueryParams(queryString);

  if (empId && competencyId && levelUpId) {
    return {
      isCompetencySidePanelRoute: true,
      employeeId: empId,
      competencyId,
      levelUpCompetencyId,
      levelUpId,
      scrollToId,
      checkInInstanceId,
      checkInParentId,
      isOneOnOne,
    };
  }
  if (empId && levelUpCompetencyId) {
    return {
      isCompetencySidePanelRoute: true,
      employeeId: empId,
      competencyId,
      levelUpCompetencyId,
      levelUpId,
      scrollToId,
      checkInInstanceId,
      checkInParentId,
      isOneOnOne,
    };
  }
  return {
    isCompetencySidePanelRoute: false,
    employeeId: empId,
    competencyId,
    levelUpCompetencyId,
    levelUpId,
    scrollToId,
    checkInInstanceId,
    checkInParentId,
    isOneOnOne,
  };
};
